import richtitleView from './richtitleComponent.html';
import './richtitleComponent.css';
import _ from 'lodash';
import bold from 'quill/assets/icons/bold.svg';
import italic from 'quill/assets/icons/italic.svg';
import color from 'quill/assets/icons/color.svg';
import background from 'quill/assets/icons/background.svg';
import alignLeft from 'quill/assets/icons/align-left.svg';
import alignCenter from 'quill/assets/icons/align-center.svg';
import alignRight from 'quill/assets/icons/align-right.svg';

export function richtitleComponent() {
	return {
		bindings: {
			model: '=',
			styling: '=',
			autohideToolbar: '<',
			placeholder: '@',
		},
		controllerAs: 'vm',
		controller: richtitleComponentCtrl,
		template: richtitleView,
	};
}

export class richtitleComponentCtrl {
	constructor($timeout) {
		'ngInject';
		this.$timeout = $timeout;
		this.icons = { bold, italic, color, background, alignLeft, alignCenter, alignRight };
		this.fontSizes = [
			{ px: '14px', name: 'Small' },
			{ px: '16px', name: 'Normal' },
			{ px: '18px', name: 'Large' },
			{ px: '20px', name: 'X-Large' },
		];
		this.fontSizeValues = _.map(this.fontSizes, 'px');
		this.fontFamilies = [
			// from http://www.adestra.com/what-need-know-using-fonts-in-email/
			{ family: 'Arial, Helvetica, sans-serif', name: 'Arial' },
			{ family: '"Bookman Old Style", serif', name: 'Bookman' },
			{ family: '"Courier New", Courier, monospace', name: 'Courier' },
			{ family: 'Garamond, serif', name: 'Garamond' },
			{ family: 'Georgia, serif', name: 'Georgia' },
			{ family: 'Impact, Charcoal, sans-serif', name: 'Impact' },
			{ family: '"Lucida Console", Monaco, monospace', name: 'Lucida Console' },
			{ family: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', name: 'Lucida Sans' },
			{ family: '"Palatino Linotype", "Book Antiqua", Palatino, serif', name: 'Palatino' },
			{ family: 'Tahoma, Geneva, sans-serif', name: 'Tahoma' },
			{ family: '"Times New Roman", Times, serif', name: 'Times' },
			{ family: '"Trebuchet MS", Helvetica, sans-serif', name: 'Trebuchet' },
			{ family: 'Verdana, Geneva, sans-serif', name: 'Verdana' },
		];
		this.fontFamilyValues = _.map(this.fontFamilies, 'family');
		this.styling = {
			fontWeight: 'bold',
			fontStyle: 'normal',
			color: '#333333',
			backgroundColor: '#FFFFFF',
			fontSize: this.fontSizes[1].px,
			fontFamily: this.fontFamilies[0].family,
			textAlign: 'left',
			...(this.styling || {}),
		};
		this.isFocused = false;
		this.isFaded = true;
	}

	toggleBold() {
		this.styling.fontWeight = this.styling.fontWeight == 'bold' ? 'normal' : 'bold';
	}

	toggleItalic() {
		this.styling.fontStyle = this.styling.fontStyle == 'italic' ? 'normal' : 'italic';
	}

	alignText(alignTo) {
		this.styling.textAlign = alignTo;
	}

	handleFocus($type) {
		if ($type == 'focus') {
			this.isFaded = false;
			this.isFocused = true;
		} else {
			this.isFocused = false;
			setTimeout(() => {
				this.isFaded = true;
				this.$timeout(() => {});
			}, 315);
		}
	}
}
